import styled from 'styled-components';

const TopFaqsQuestions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TopFaqsQuestion = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export { TopFaqsQuestion, TopFaqsQuestions };
